import { TimechiefClient } from "../timechiefclient";

class MockGoogleProfileService {
    constructor() {
        this.fail = false;
        this.isLinked = true;
        this.hasEmail = true;
    }

    getAccountDetails() {
        if (this.fail) {
            return Promise.reject("fail");
        }
        const details = {
            is_linked: this.isLinked,
            uuid: "1234",
            email_address: this.hasEmail ? "test@example.org" : "",
            dt: 1701532850
        };
        return Promise.resolve(details);
    }

    deletePrincipalGoogleAccount() {
        if (this.fail) {
            return Promise.reject("fail");
        }
        return Promise.resolve();
    }

    getAuthURL() {
        if (this.fail) {
            return Promise.reject("fail");
        }
        return Promise.resolve({
            url: "https://example.org"
        });
    }

}

class GoogleProfileService {
    getAccountDetails() {
        return TimechiefClient.default.getMyPrincipalGoogleAccount().then((link) => {
            return TimechiefClient.default.getMyGoogleProfile().then(profile => {
                return {
                    is_linked: true,
                    uuid: link.uuid,
                    email_address: profile.email_address,
                    dt: profile.dt
                };
            }).catch((err) => {
                console.log("error getting profile");
                console.log(err);
                return {
                    is_linked: true,
                    uuid: link.uuid,
                    email_address: "",
                    dt: 0
                };
            });
        }).catch((err) => {
            console.log("error getting google account link");
            console.log(err);
            return {
                is_linked: false,
                uuid: "",
                email_address: "",
                dt: 0
            };
        });
    }
    getPrincipalGoogleAccount() {
        return TimechiefClient.default.getMyPrincipalGoogleAccount();
    }

    deletePrincipalGoogleAccount() {
        return TimechiefClient.default.deleteMyPrincipalGoogleAccount();
    }

    getGoogleProfile() {
        return TimechiefClient.default.getMyGoogleProfile();
    }

    getAuthURL() {
        return TimechiefClient.default.getMyGoogleAuthUrl();
    }
}

export const Service = new GoogleProfileService();